<div class="two-columns-2-1" *ngIf="organisationEditForm" style="padding-bottom: 40px;">
    <form [formGroup]="organisationEditForm">
        <div class="columns-50-50">
            <mat-form-field>
                <mat-label>Name der Organisation</mat-label>
                <input matInput formControlName="name" (input)="changeDomainToName(nameInputField.value)" required
                    #nameInputField [errorStateMatcher]="orgaNameErrorStateMatcher" maxlength="161"
                    (blur)="trimField('name')" />
                <mat-error>
                    {{ utilService.getFormControlErrorMessage(name, {includeMinLength: true}) }}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Art der Organisation</mat-label>
                <mat-select formControlName="type" multiple required [disabled]="!isNewOrganisation">
                    <mat-option value="PRODUCT_PROVIDER">
                        Produktanbieter
                    </mat-option>
                    <mat-option value="PRODUCT_TYPE_ASSOCIATION">
                        Fachgruppe
                    </mat-option>
                    <mat-option value="CERTIFICATION_PROVIDER">
                        Zertifizierungsanbieter
                    </mat-option>
                    <mat-option value="CERTIFICATION_OFFICE">
                        Zertifizierungsdienstleister
                    </mat-option>
                    <mat-option value="DATASPACE_PARTICIPANT">
                        Datenraum Participant
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="type.hasError('required')">
                    Dieses Feld darf nicht leer sein.
                </mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="type.value?.includes('DATASPACE_PARTICIPANT')">
                <mat-select placeholder="Art der Registrierungsnummer" formControlName="registrationType" required>
                    <mat-option value="gx:vatID">VAT ID</mat-option>
                    <mat-option value="gx:leiCode">LEI Code</mat-option>
                    <mat-option value="gx:EORI">EORI</mat-option>
                </mat-select>
                <mat-error *ngIf="registrationType.hasError('required')">
                    Diese Angabe ist erforderlich
                </mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="type.value?.includes('DATASPACE_PARTICIPANT')">
                <input matInput placeholder="Registrierungsnummer" formControlName="registrationNumber" required />
                <mat-error *ngIf="registrationNumber.hasError('required')">
                    Diese Angabe ist erforderlich
                </mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="type.value?.includes('DATASPACE_PARTICIPANT')">
                <input matInput placeholder="Ländercode (z.B. DE)" formControlName="countryCode" required
                    maxlength="2" />
                <mat-error *ngIf="countryCode.hasError('required')">
                    Diese Angabe ist erforderlich
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Straße</mat-label>
                <input matInput formControlName="street" required (blur)="trimField('street')" />
                <mat-error *ngIf="street.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                <mat-error *ngIf="!street.hasError('required') && street.hasError('specialCharFound')">
                    Bitte keine Sonderzeichen benutzen.
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Hausnummer</mat-label>
                <input matInput formControlName="hNr" required (blur)="trimField('hNr')" />
                <mat-error *ngIf="hNr.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                <mat-error *ngIf="hNr.hasError('maxlength')">
                    Hausnummer ist zu lang
                </mat-error>
                <mat-error *ngIf="!hNr.hasError('maxlength') && hNr.hasError('pattern')">
                    Bitte gültige Hausnummer eingeben
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Postleitzahl</mat-label>
                <input matInput formControlName="postalCode" (blur)="trimField('postalCode')" required />
                <mat-error *ngIf="postalCode.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                <mat-error *ngIf="!postalCode.hasError('required') && postalCode.hasError('pattern')">
                    Bitte eine gültige Postleitzahl eingeben 
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Ort</mat-label>
                <input matInput formControlName="city" (blur)="trimField('city')" required />
                <mat-error *ngIf="city.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                <mat-error *ngIf="!city.hasError('required') && city.hasError('pattern')">
                    Bitte mindestens zwei Zeichen eingeben und das erste Zeichen
                    bitte groß schreiben
                </mat-error>
            </mat-form-field>
            <!-- <mat-form-field>
                <mat-label>Kurzbezeichnung</mat-label>
                <input matInput formControlName="domain" required #domainInputField />
                <span matPrefix>{{ domainPrefix }}</span>
                <mat-error *ngIf="domain.hasError">
                    Dieses Feld darf nicht leer sein.
                </mat-error>
            </mat-form-field> -->
            <mat-form-field>
                <mat-label>Website</mat-label>
                <input matInput formControlName="url" type="url" />
                <mat-error *ngIf="url.hasError('websiteLength')">
                    Die Website darf maximal 60 Zeichen lang sein
                </mat-error>
                <mat-error *ngIf="url.hasError('invalidUrl') && !url.hasError('websiteLength')">
                    Bitte eine valide Website angeben
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Telefonnummer</mat-label>
                <input matInput formControlName="phoneNumber" autocomplete="tel" (blur)="checkPhonenumber()" />
                <mat-error *ngIf="phoneNumber.invalid">
                    Bitte eine gültige Telefonnummer angeben
                </mat-error>
            </mat-form-field>
        </div>
        <form #form="ngForm">
            <app-text-editor [(editorText)]="organisation.description"
                (textValidityChange)="onDescriptionValidityChange($event)"></app-text-editor>
        </form>
        <p *ngIf="isNewOrganisation">
            Wenn Sie eine neue Organisation auf der Plattform einstellen, werden
            Sie automatisch der Administrator dieser Organisation
        </p>
        <div class="contact-container">
            <div class="contact-header">
                <h2>Kontakt</h2>
                <mat-icon matSuffix class="info-icon"
                    matTooltip="Demo- und Angebotsanfragen von der Produktseite werden an diesen Kontakt gesendet. Ist kein Kontakt hinterlegt, sind diese Funktionen deaktiviert."
                    matTooltipPosition="above" tabindex="-1" style="margin-top: 5px;">
                    info_outline
                </mat-icon>
            </div>
            <mat-slide-toggle formControlName="createContact">
                Kontakt erstellen
            </mat-slide-toggle>
            <div *ngIf="organisationEditForm.get('createContact').value" formGroupName="contact"
                class="columns-50-50 mg">
                <mat-form-field>
                    <mat-label>Kontaktperson</mat-label>
                    <input matInput formControlName="contactName" required
                        (blur)="trimField('contactName', 'contact')" />
                    <mat-error *ngIf="contactName.hasError('required')">
                        Bitte einen Namen angeben
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>E-Mail</mat-label>
                    <input matInput formControlName="email" required (blur)="trimField('email', 'contact')" />
                    <mat-error *ngIf="contactEmail.hasError('required') || contactEmail.hasError('email')">
                        Bitte gültige E-Mail angeben
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="type.value?.includes('DATASPACE_PARTICIPANT')" style="margin-bottom: 20px; margin-top: 10px;">
            <mat-checkbox formControlName="termsAndConditions">
                Ich bestätige die Gaia-X Terms and Conditions
            </mat-checkbox>
            <mat-error *ngIf="termsAndConditions.invalid && (termsAndConditions.dirty || termsAndConditions.touched)"
                class="text-warn" style="font-size: 75%; margin-top: 5px;">
                Die Bedingungen müssen akzeptiert werden.
            </mat-error>
        </div>
        <div class="columns-50-50">
            <button matButton="elevated" color="warn" (click)="onAbort()">
                Abbrechen
            </button>
            <button matButton="elevated" class="green-confirm" (click)="onOrganisationConfirm()"
                [disabled]="organisationEditForm.invalid || !isDescriptionValid || !organisation.fileId">
                Speichern
            </button>
        </div>
    </form>
    <div>
        <app-logo [fileId]="organisation.fileId" (logoChanged)="organisation.fileId = $event"></app-logo>
    </div>
</div>

<div *ngIf="isLoading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>
